import React, {useEffect, useState} from 'react';
import {BsFillEyeFill, BsFillEyeSlashFill} from "react-icons/bs";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import FluxerLogo from "../images/Group 220.svg";
import {authenticateUser, checkUser, loginUser} from "../redux-store/auth";
import {get2FaStatus, getLoginPassedStatus, isAuthenticated} from "../redux-store/selectors";
import {useNavigate} from "react-router-dom";
import ErrorIcon from "../images/errorIcon.png"
import {REQUIRED_FIELD} from "../constants/Messages";
import {Link} from "react-router-dom";

const LoginComponent = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm();
    const [showPassword, setShowPassword] = useState(false)
    const authenticated = useSelector(isAuthenticated);
    const loginPassed = useSelector(getLoginPassedStatus);
    const twoFactorAuth = useSelector(get2FaStatus);

    const togglePassword = () => {
        setShowPassword(showPassword ? false : true)
    }

    useEffect(() => {
        if (authenticated)
            navigate("/")
    }, [authenticated])

    useEffect(() => {
        if (loginPassed && !twoFactorAuth)
            dispatch(authenticateUser());
        else if(loginPassed && twoFactorAuth)
            navigate("/two_fa");
    }, [loginPassed]);


    const onsubmit = (data) => {
        dispatch(loginUser(data))
        checkUser();
    }

    const [inputValue, setInputValue] = useState(false);

    const handleInputChange = (event) => {
      setInputValue(event.target.checked);
    };

    return (
        <div className="login-background">
            <div className="container position-absolute card-top top-50 start-50 translate-middle">
                <div className="row justify-content-sm-center">
                    <div className="col-xl-4 col-lg-5 col-md-6 col-sm-10 login-card">
                        <div className="card">
                            <div className="card-body p-3">
                                <h1 className="fs-4 card-title fw-bold mb-5 text-center text-white pt-2"><img
                                    src={FluxerLogo}/></h1>
                                <form onSubmit={handleSubmit(onsubmit)}>
                                    <div className="mb-4">
                                        <label className="mb-2 text-white login-label" htmlFor="username">Korisničko
                                            ime</label>
                                        <input type="text"
                                               className="form-control"
                                               name={"username"}
                                               {...register("username", {required: true})}/>
                                        {errors.username && (
                                            <span className="loggin-error"><img
                                                src={ErrorIcon}/> {REQUIRED_FIELD}</span>
                                        )}
                                    </div>

                                    <div className="mb-4">
                                        <div className="mb-2 w-100">
                                            <label className="text-white login-label" htmlFor="password">Lozinka</label>
                                        </div>
                                        <div className="input-group mb-3">
                                            <input type={showPassword ? "text" : "password"}
                                                   className="form-control password-eye-input"
                                                   name={"password"}
                                                   {...register("password", {required: true})}/>
                                            <span className="input-group-text password-eye" id="basic-addon2"
                                                  onClick={togglePassword}>{showPassword ? <BsFillEyeSlashFill/> :
                                                <BsFillEyeFill/>}</span>
                                        </div>
                                        {errors.password && (
                                            <span className="loggin-error"><img
                                                src={ErrorIcon}/> {REQUIRED_FIELD}</span>
                                        )}
                                    </div>
                                    <div className='mb-2 text-white'>
                                        <input type='checkbox' value={inputValue} onClick={handleInputChange}></input>&nbsp;Slažem se sa <Link to={"/agreement"} target='_blank'>pravilima korištenja</Link>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <button type="submit" className="btn btn-main w-100" disabled={!inputValue}>
                                            Prijavi se
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginComponent;
